export const mapFabricData = (fabric) => {
	const imageUrl = `https://dealerportal.mysunglow.com/${encodeURI(
		fabric?.image ?? ""
	)}/${(fabric.Colour ?? "").toLowerCase()}.jpg`;
	const colorDesc = fabric.Colour ?? "No color specified";

	return {
		original: imageUrl,
		thumbnail: imageUrl,
		description: colorDesc,
		originalAlt: colorDesc,
		thumbnailAlt: colorDesc,
		originalClass: "custom-original-image",
		...fabric,
		SKU: fabric.Code,
		railroad: fabric.Railroad,
		width: fabric.Width,
		composition: fabric.Composition,
		fireRating: fabric.Fire_Rating,
		greenRating: fabric.Green_Rating,
		antimicrobialRating: fabric.Antimicrobial_Rating,
		graphicAllowed: fabric.graphic_shade,
	};
};

export const INITIAL_FILTERS = {
	shade: "Roller",
	group: "All",
	color: "All",
	"eco-friendly": false,
	"fire-resistant": false,
	"anti-microbial": false,
};
